import React, { useState, useEffect } from "react";
import NewHeader from "../../components/NewHeader/NewHeader";
import Footer from "../../components/Footer/Footer";
import Navigation from "../../components/BreadNav/Navigation";
import { razorKey } from "../../config/Axios";
import "./Giftcard.css";
import useRazorpay from "react-razorpay";
import { VerfiyUser, getCustomerDashboard } from "../../Redux/Actions.js";
import { useDispatch, useSelector } from "react-redux";
import handlePayment from "./Razorpay.js";
import Axios from "../../config/Axios";
import Prefix from "../../config/ApiPrefix";
function Giftcard() {
  const [giftAmount, setGiftAmount] = useState("");
  const Razorpay = useRazorpay();
  const VerifyStatus = useSelector((state) => state.VerfiyUserReducer);
  const isLogout = useSelector((state) => state.setLogoutReducer);
  console.log("isLogiut", isLogout);
  const { loading: VerifyLoading, status } = VerifyStatus;

  const userProfile = useSelector((state) => state.customerDashboard);
  const { loading: userLoading, packages } = userProfile;

  console.log("profile data", userProfile);
  const [amountError, setAmoutnError] = useState("");

  const dispatch = useDispatch();
  const [name, setuserName] = useState("");
  const [nameError, setNameEror] = useState("");
  const [disable, setDisable] = useState(true);
  const [phone, setphone] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const [email, setEmail] = useState("");

  const [successMsg, setSuccss] = useState("");
  //handel gift card
  const setGiftPrice = (price) => {
    setGiftAmount(price);
  };
  /////////
  // useEffect(() => {
  //   if (localStorage.getItem("user")) {

  //     const datekey = JSON.parse(localStorage.getItem("user"));
  //     const token = datekey && datekey?.token;
  //     token !== undefined && token !== ""
  //       ? dispatch(getCustomerDashboard(token))
  //       : null;
  //   } else {
  //     console.log("no user");
  //   }
  // }, []);
  //
  const paymentSuccess = (str) => {
    setSuccss(str);
    setTimeout(() => {
      setSuccss("");
    }, 2000);
  };
  ////////NAME
  const handelUsername = (e) => {
    setuserName(e.target.value);

    const characterRegex =/^([A-Za-z]+[ ]?)+$/;
    setNameEror("");
    if (!e.target.value.match(characterRegex)) {
      setNameEror("Invalid username");
    }
    if (e.target.value == "") {
      setNameEror("");
    }
  };
  ////EMAIL
  const handelemail = (e) => {
    setEmail(e.target.value);
  };

  //phone
  const handelPhone = (e) => {
    setphone(e.target.value);
    setPhoneError("");
  };

  const validatePhoneNumber = () => {
    let phoneno = /^\d{10}$/;
    if (!phone.match(phoneno) || parseInt(phone[0]) < 6 || phone.length < 10) {
      setPhoneError("Enter a valid number");
      console.log(phone);
    } else {
      setPhoneError("");
      console.log(phone);
    }
  };

  const handelVerfiyUser = (e) => {
    e.preventDefault();

    setEmail("");
    setuserName("");
    setphone("");
    setGiftAmount("");
    handlePayment();
  };

  ///
  useEffect(() => {
    if (
      name == "" ||
      email == "" ||
      phone == "" ||
      phone?.length !== 10 ||
      amountError != "" ||
      giftAmount == "" ||
      phoneError != ""
    ) {
      setDisable(true);
      console.log("phone error", phoneError);
    } else {
      setDisable(false);
      console.log("phone error", phoneError);
    }
  }, [name, phone, email, amountError, giftAmount, phoneError]);
  ////////handel payment

  const VerfiyUserPromise = () => {
    const body = {
      phonenumber: phone,
      email: email,
      fullname: name,
    };

    return new Promise((resolve, reject) => {
      Axios.post(`${Prefix.api}/panel/user-from-phone-email/`, body)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          alert(JSON.stringify(error.response));
          // window.alert("A booking is already done with this number for same collection date.")
        });
    });
  };
  const handlePayment = async (params) => {
    // const order = await createOrder(params); //  Create order on your backend
    VerfiyUserPromise()
      .then((res) => {
        const options = {
          key: "rzp_live_sDovuuBgCu9dw3", // Enter the Key ID generated from the Dashboard
          // key: "rzp_test_kBEHIT9OH5OYyo",
          amount: giftAmount * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
          currency: "INR",
          name: "Redcliffe Labs",
          description: "Gift card transaction",
          // image:
          //   "https://staticcdn.redcliffelabs.com/media/gallary-file/None/a0f82e2b-5cee-4694-a972-2514e9bd3694.svg",
          //This is a sample Order ID. Pass the `id` obtained in the response of createOrder().
          handler: function(response) {
            console.log(response, "=====>response");
            const body = {
              paymentid: response?.razorpay_payment_id,

              gift_card: true,
              uuid: res?.user_id,
            };
            dispatch(VerfiyUser(body));

            paymentSuccess("Payment Successful !");
          },
          prefill: {
            name,
            email,
            contact: phone,
          },
          notes: {
            gift_card: true,
            uuid: res?.user_id,
          },
          theme: {
            color: "#0a406b",
          },
          // callback_url : `${Prefix.api}/payment/order_payment_link_status/`,
        };

        const rzp1 = new Razorpay(options);

        rzp1.on("payment.failed", function(response) {
          // alert(response.error.code);
          // alert(response.error.description);
          // alert(response.error.source);
          // alert(response.error.step);
          alert(response.error.reason);
          // alert(response.error.metadata.order_id);
          // alert(response.error.metadata.payment_id);
        });

        rzp1.open();
      })
      .catch((error) => {
        rzp1.open();
        console.log(error.message);
      });
  };

  ///handel amount

  const handelAmount = (e) => {
    setGiftAmount(e.target.value);
    if (e.target.value == "") {
      setAmoutnError("Please enter amount");
    } else if (e.target.value < 500) {
      setAmoutnError("Minimum amount is  ₹500");
    } else {
      setAmoutnError("");
    }
  };

  // //////////
  // useEffect(() => {
  //   if(isLogout && isLogout?.isLogout && isLogout?.isLogout !==""){
  //     setuserName("");
  //     setphone("");
  //     setEmail("");
  //   }
  // },[isLogout])

  useEffect(() => {
    if (isLogout && isLogout?.isLogout && isLogout?.isLogout !== "") {
      setuserName("");
      setphone("");
      setEmail("");
    } else {
      if (userLoading) {
      } else if (userLoading == false) {
        if (packages && packages?.profile && packages?.profile) {
          setuserName(packages?.profile?.fullname);
          setphone(packages?.profile?.phonenumber);
          setEmail(packages?.profile?.email);
        } else {
          setuserName("");
          setphone("");
          setEmail("");
        }
      }
    }
  }, [userProfile, isLogout]);
  return (
    <div className="giftcard">
      <NewHeader />

      <div className="giftCard_content">
        {/* <Navigation /> */}
        <div className="giftbackground">
          <div className="leftgift">
            <h1>Give a gift of good health to your loved ones</h1>
          </div>
          <div className="rightgift">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/e5980779-95f6-44b6-9e4e-fb0dde59f92f.png"
              alt="gift"
              className="giftimg"
            />
          </div>
        </div>
        <div className="newGiftDiv">
          <div className="giftInfo">
            <div className="gift_top">
              <h3>ADD GIFT CARD </h3>
              {/* <h5>
              Gift Card Balance: <span style={{ color: "#31CCB0" }}>₹0.00</span>
            </h5> */}
            </div>
            <div className="horLine" />
            <div>
              <div className="gift_bottom">
                <div className="priceDistribution">
                  <div className="priceFomr">
                    <div className="priceBox">
                      <div className="choose">Choose An Amount:</div>
                      <span
                        className={giftAmount == 500 ? "activeLink" : ""}
                        onClick={() => {
                          setGiftPrice(500), setAmoutnError("");
                        }}
                      >
                        ₹500
                      </span>
                      <span
                        className={giftAmount == 1000 ? "activeLink" : ""}
                        onClick={() => {
                          setGiftPrice(1000), setAmoutnError("");
                        }}
                      >
                        ₹1000
                      </span>
                      <span
                        className={giftAmount == 2000 ? "activeLink" : ""}
                        onClick={() => {
                          setGiftPrice(2000), setAmoutnError("");
                        }}
                      >
                        ₹2000
                      </span>
                      <span
                        className={giftAmount == 5000 ? "activeLink" : ""}
                        onClick={() => {
                          setGiftPrice(5000), setAmoutnError("");
                        }}
                      >
                        ₹5000
                      </span>
                      <span
                        className={giftAmount == 10000 ? "activeLink" : ""}
                        onClick={() => {
                          setGiftPrice(10000), setAmoutnError("");
                        }}
                      >
                        ₹10000
                      </span>
                      <div
                        className="inputPrice "
                        style={{ color: "#000", fontWeight: "700" }}
                      >
                        ₹
                        <input
                          className="giftInput"
                          placeholder="Enter the amount"
                          type="number"
                          value={giftAmount}
                          onChange={handelAmount}
                          style={{ fontWeight: "700", color: "black" }}
                        />
                      </div>

                      <small style={{ color: "red", fontSize: "12px" }}>
                        {amountError}
                      </small>
                      {/* <button onClick={handlePayment}>pay</button> */}
                    </div>
                    <div className="verLine" />
                    <div className="rightFomr">
                      <form
                        className="giftCardForm"
                        onSubmit={handelVerfiyUser}
                      >
                        <div className="choose mobileachosse">
                          Enter Purchase Details:
                        </div>
                        <div className="divInp">
                          <div className="inputDiv_Gift">
                            <input
                              type="text"
                              placeholder="Name"
                              onChange={handelUsername}
                              value={name}
                              required
                              className="mobileInput"
                            />
                            <span style={{ color: "red", fontSize: "12px" }}>
                              {nameError}
                            </span>
                          </div>
                          <div className="inputDiv_Gift">
                            <input
                              type="text"
                              placeholder="Phone Number"
                              required
                              value={phone}
                              onChange={handelPhone}
                              onBlur={validatePhoneNumber}
                              className="mobileInput"
                            />
                            <span style={{ color: "red", fontSize: "12px" }}>
                              {phoneError}
                            </span>
                          </div>
                          <div className="inputDiv_Gift">
                            <input
                              type="email"
                              placeholder="Enter Email ID"
                              required
                              className="mobileInput"
                              value={email}
                              onChange={handelemail}
                            />
                            <span
                              style={{ color: "red", fontSize: "12px" }}
                            ></span>
                          </div>
                          <button
                            disabled={disable ? "disabled" : ""}
                            className={disable ? "disabled" : ""}
                            type="submit"
                          >
                            BUY GIFT CARD
                          </button>
                        </div>
                      </form>
                      <p className="success">{successMsg}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text_content priceDetailsDiv">
            <p style={{ fontWeight: "500" }}>
              All Gift Cards Qualify For A Cashback Of 10% To 25%
            </p>
            <p>Gift card of &#8377;500 - &#8377;1999 : 10% Cashback </p>
            <p>Gift card of &#8377;2000 - &#8377;4999 : 20% Cashback</p>
            <p> Gift card of &#8377;5000 & Above : 25% Cashback </p>

            <p>
              Expires on: 6 months from the date of purchase if not used with in
              6 months.
            </p>
          </div>
        </div>

        {/* <p className="notepara">
          This information will help us provide the user with a gift card of
          their choice
        </p> */}
        <div className="text_content deskNoMobYO ">
          <p style={{ fontWeight: "500" }}>
            All Gift Cards Qualify For A Cashback Of 10% To 25%
          </p>
          <p>Gift card of &#8377;500 - &#8377;1999 : 10% Cashback </p>
          <p>Gift card of &#8377;2000 - &#8377;4999 : 20% Cashback</p>
          <p> Gift card of &#8377;5000 & Above : 25% Cashback </p>

          <p>
            Expires on: 6 months from the date of purchase if not used with in 6
            months.
          </p>
        </div>

        <div className="text_content">
          <h4 style={{ margin: "1rem 0" }}>How To Redeem This Gift Card</h4>
          <p>
            - This Gift Card is applicable on RCL website/app. To use the Gift
            Card the steps are as follows
          </p>
          <p> - Login to RCL website www.redcliffelabs.com or RCL App</p>
          <p>
            - Now add the Diagnostic Test you want to purchase in your cart.
          </p>
          <p>
            {" "}
            - Click on 'Add payment methods'. Select Gift Card and enter you
            unique Gift Card Code.{" "}
          </p>
          <p> - The Gift Card amount will get deducted from the final price.</p>
        </div>

        <div className="text_content TandC">
          <h4 style={{ margin: "1rem 0" }}>Terms And Conditions</h4>
          <p>
            - Valid at RCL Website/App and only for booking Diagnostic Test. So
            please check before purchasing one.
          </p>
          {/* <p>- Valid only on total cart worth ₹500 or more.</p> */}
          <p>
            {" "}
            - This is Digital Gift Card will send to the buyer by email only, on
            their communication email address.{" "}
          </p>
          <p>
            - The card can be used as payment for any products we have. Balance
            is shown and is available for future payments.
          </p>
          <p>
            {" "}
            - Cannot be clubbed with any other ongoing offer discount/cash
            back/promotion run by RCL{" "}
          </p>
          <p>
            - Two or more Gift Card cannot be clubbed together to make a
            transaction.
          </p>
          <p>- This Gift Card cannot be exchanged for Cash or Cheque.</p>
          <p> - This Gift Card cannot be cancelled, refunded or returned. </p>
          <p> - This Gift Card in non-refundable.</p>
          <p>
            - In addition to the above, this offer is also subject to the RCL
            general Terms of Use.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default { component: Giftcard };
